import { render, staticRenderFns } from "./bi-form-view-vehicle.vue?vue&type=template&id=65cb6353&scoped=true&"
import script from "./bi-form-view-vehicle.vue?vue&type=script&lang=ts&"
export * from "./bi-form-view-vehicle.vue?vue&type=script&lang=ts&"
import style0 from "./bi-form-view-vehicle.vue?vue&type=style&index=0&id=65cb6353&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cb6353",
  null
  
)

export default component.exports